import React from "react";
import styled from "styled-components";
import Gallery from "react-photo-gallery";

import Article from "components/article";
import media from "utils/media-queries";
import { v } from "utils/v-size";
import UISrc from "img/articles/lifetime/lifetime-app.jpg";
import TasksSrc from "img/articles/lifetime/lifetime-tasks.jpg";
import OnboardingSrc from "img/articles/lifetime/lifetime-illustration.svg";
import IconsSrc from "img/articles/lifetime/lifetime-icons.svg";
import LogoSrc from "img/articles/lifetime/lifetime-logo.svg";
import HeartSpinnerSrc from "img/articles/lifetime/lifetime-logoanimation.gif";
import { color } from "styles/theme";
import Seo from "components/seo";

const photos = [
  { src: TasksSrc, width: 1500, height: 1215, alt: "Tasks" },
  { src: UISrc, width: 1500, height: 1054, alt: "UI" },
  { src: IconsSrc, width: 1276, height: 1016, alt: "Icons" },
  { src: LogoSrc, width: 1177, height: 381, alt: "Logo" },
  { src: OnboardingSrc, width: 1011, height: 394, alt: "Onboarding" },
  { src: HeartSpinnerSrc, width: 400, height: 400, alt: "Heart Spinner" },
];

const GalleryOuterWrapper = styled.div`
  padding: 0 ${v(20, 140)} 0 ${v(20, 140)};
`;

const GalleryWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;

  .react-photo-gallery--gallery {
    width: 100% !important;
  }

  .react-photo-gallery--gallery img {
    border-radius: 16px;
    background: ${color.coolGrey200};
  }
`;

const LifeTime = () => {
  return (
    <Article
      title="LifeTime"
      description="Secure medical messenger"
      from="2014"
      to="2022"
      roles={["Co-Founder", "Head of Product Design", "Frontend Developer"]}
      text={
        <>
          <p>
            LifeTime is an end-to-end encrypted messaging solution, medication
            and document manager for the German healthcare market.
          </p>
          <p>
            It runs on iOS, Android, Windows, Linux and MacOS and integrates
            with multiple native and web components. This variety of target
            platforms made designing the product an exciting challenge.
          </p>
          <p>
            LifeTime attracted more than 500.000 users (patients & doctors) and
            was acquired in early 2022.
          </p>
        </>
      }
      more={
        <>
          <Seo title="LifeTime" />
          <GalleryOuterWrapper>
            <GalleryWrapper>
              <Gallery
                photos={photos}
                targetRowHeight={500}
                margin={20}
                limitToOneRow={false}
                targetRowHeightTolerance={0.1}
              />
            </GalleryWrapper>
          </GalleryOuterWrapper>
        </>
      }
    />
  );
};

export default LifeTime;
